// extracted by mini-css-extract-plugin
export default {"footerContainer":"footer_footerContainer__N6rrV","footerHeader":"footer_footerHeader__ow6y6","footerSection":"footer_footerSection__DWhDb","footerItem":"footer_footerItem__6178D"};